module.exports = __webpack_public_path__ + "r-v3/img/ml_10_00.6438f631.jpg";